export const generatedAsteroidCandidateEvidenceLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-asteroid-candidate-evidence-ledger",
  "operatingRule": "Asteroid candidate records can support scanner workflow only until object-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence is attached and hash-backed.",
  "candidateCount": 3,
  "blockedCandidateCount": 3,
  "promotionAllowed": false,
  "requiredEvidenceTypes": [
    {
      "id": "sbdb-orbit-record",
      "label": "SBDB orbit and physical-property record",
      "sourceIds": [
        "sbdb-api"
      ],
      "requiredFor": "Orbit solution, condition code, absolute magnitude, diameter fields, and physical property provenance.",
      "acceptedSourceRefs": [
        {
          "sourceId": "sbdb-api",
          "title": "JPL Small-Body Database API",
          "trust": "primary",
          "sourceType": "small-body-orbit-api",
          "recordHash": "fnv1a32-93c0fe91",
          "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
          "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
          "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
        }
      ]
    },
    {
      "id": "cad-close-approach-record",
      "label": "CAD close-approach record",
      "sourceIds": [
        "cad-api"
      ],
      "requiredFor": "Close approach cadence, nominal distance, relative velocity, and date range.",
      "acceptedSourceRefs": [
        {
          "sourceId": "cad-api",
          "title": "SBDB Close Approach Data API",
          "trust": "primary",
          "sourceType": "close-approach-api",
          "recordHash": "fnv1a32-ba0c45bb",
          "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
          "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
          "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
        }
      ]
    },
    {
      "id": "mpc-observation-bridge",
      "label": "MPC observation bridge",
      "sourceIds": [
        "mpc"
      ],
      "requiredFor": "Observation context that explains orbit confidence and designation lineage.",
      "acceptedSourceRefs": [
        {
          "sourceId": "mpc",
          "title": "Minor Planet Center Data",
          "trust": "primary",
          "sourceType": "small-body-observation-archive",
          "recordHash": "fnv1a32-62694497",
          "url": "https://minorplanetcenter.net/data",
          "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
          "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
        }
      ]
    },
    {
      "id": "taxonomy-spectra-record",
      "label": "Taxonomy or spectra record",
      "sourceIds": [
        "pds",
        "esa-psa",
        "jaxa-darts"
      ],
      "requiredFor": "Resource-class evidence; close approaches cannot imply composition.",
      "acceptedSourceRefs": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/",
          "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
          "uncertaintyMode": "Instrument/product calibration metadata."
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "trust": "primary",
          "sourceType": "planetary-mission-archive",
          "recordHash": "fnv1a32-5c0abe4d",
          "url": "https://archives.esac.esa.int/psa/",
          "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
          "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "trust": "primary",
          "sourceType": "space-science-archive",
          "recordHash": "fnv1a32-e07b656d",
          "url": "https://darts.isas.jaxa.jp/",
          "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
          "uncertaintyMode": "Dataset calibration and archive release notes."
        }
      ]
    },
    {
      "id": "mission-or-archive-product",
      "label": "Mission/archive product",
      "sourceIds": [
        "pds",
        "esa-psa",
        "jaxa-darts"
      ],
      "requiredFor": "Independent mission data or archive product where material claims depend on composition.",
      "acceptedSourceRefs": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/",
          "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
          "uncertaintyMode": "Instrument/product calibration metadata."
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "trust": "primary",
          "sourceType": "planetary-mission-archive",
          "recordHash": "fnv1a32-5c0abe4d",
          "url": "https://archives.esac.esa.int/psa/",
          "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
          "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "trust": "primary",
          "sourceType": "space-science-archive",
          "recordHash": "fnv1a32-e07b656d",
          "url": "https://darts.isas.jaxa.jp/",
          "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
          "uncertaintyMode": "Dataset calibration and archive release notes."
        }
      ]
    }
  ],
  "evidenceHashes": {
    "asteroidCandidates": "sha256-f918aed636e14510f07a16f1f501ff0b76a051cf9816855dfacd59e74c81b622",
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "smallBodySourceCandidateLedger": "sha256-ee609d008f0470c727ad738d35e9787a186b9e6c3d1fc92f4e37b74e2e1b28cd",
    "liveSmallBodyReviewQueue": "sha256-5c15135920e0213d2fe953e13a47ef1fdd410b577ff30f5c9d7c49fea2a8089f",
    "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
    "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00"
  },
  "sourceCandidateEvidence": {
    "ledgerHash": "sha256-ee609d008f0470c727ad738d35e9787a186b9e6c3d1fc92f4e37b74e2e1b28cd",
    "geometryCandidateCount": 10,
    "sourceRowCount": 10,
    "payloadState": "live-capture-review-candidate",
    "resourcePromotionAllowed": false,
    "operatingRule": "CAD/SBDB candidate evidence may rank logistics geometry, but resource composition remains blocked until taxonomy, spectra, or mission/archive evidence is attached."
  },
  "liveReviewQueueEvidence": {
    "queueHash": "sha256-5c15135920e0213d2fe953e13a47ef1fdd410b577ff30f5c9d7c49fea2a8089f",
    "reviewCandidateCount": 10,
    "blockedReviewCandidateCount": 10,
    "queueState": "review-required",
    "resourcePromotionAllowed": false,
    "customerUseAllowed": false,
    "sourceUseReviewRequired": true
  },
  "candidateSourceWorkOrderCount": 10,
  "candidateSourceWorkOrders": [
    {
      "id": "small-body-source-work-order-2026-jm2",
      "sourceCandidateId": "cad-2026 JM2",
      "designation": "2026 JM2",
      "name": "2026 JM2",
      "queueRank": 1,
      "reviewPriorityScore": 52.39,
      "currentEvidenceState": "geometry-screen-only",
      "workOrderState": "blocked-until-candidate-specific-source-intake",
      "promotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "sourceQueryTargets": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "sourceId": "sbdb-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+JM2&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
          "requiredFor": "Object identity, orbit solution, physical fields, close-approach cross-check, and uncertainty custody."
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "sourceId": "cad-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+JM2&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
          "requiredFor": "Candidate-specific close-approach cadence, distance, velocity, diameter fields, and CAD uncertainty custody."
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "sourceId": "mpc",
          "method": "manual-review",
          "url": "https://minorplanetcenter.net/data",
          "requiredFor": "Designation lineage, observation arc, residual context, and bridge between MPC observation records and SBDB/CAD identity."
        }
      ],
      "archiveSearchTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 JM2",
            "2026 JM2 asteroid taxonomy",
            "2026 JM2 spectra",
            "2026 JM2 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 JM2",
            "2026 JM2 asteroid taxonomy",
            "2026 JM2 spectra",
            "2026 JM2 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 JM2",
            "2026 JM2 asteroid taxonomy",
            "2026 JM2 spectra",
            "2026 JM2 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        }
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "acceptanceGates": [
        "Candidate designation resolves unambiguously across SBDB, CAD, and MPC records.",
        "All source payloads include query URL, timestamp, units, uncertainty, license/use note, and hashes.",
        "Taxonomy, spectra, or mission/archive evidence is attached before any resource-class hypothesis is promoted.",
        "If no composition evidence is found, the work order closes as no-promotion with blockers preserved.",
        "Customer-facing reports may reference geometry screening only after source-use clearance."
      ],
      "stopConditions": [
        "SBDB/CAD/MPC records refer to different objects or ambiguous designations.",
        "Archive search cannot produce a candidate-specific taxonomy, spectra, or mission product.",
        "License or source-use review blocks redistribution or customer use.",
        "Resource class would be inferred only from close-approach geometry or orbit class."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jm2-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-b52331ce9a5cd6c17d6aafaa4119aee5533301a87cded5d6a06e684cf07fa134"
    },
    {
      "id": "small-body-source-work-order-2026-em",
      "sourceCandidateId": "cad-2026 EM",
      "designation": "2026 EM",
      "name": "2026 EM",
      "queueRank": 2,
      "reviewPriorityScore": 44.28,
      "currentEvidenceState": "geometry-screen-only",
      "workOrderState": "blocked-until-candidate-specific-source-intake",
      "promotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "sourceQueryTargets": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "sourceId": "sbdb-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+EM&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
          "requiredFor": "Object identity, orbit solution, physical fields, close-approach cross-check, and uncertainty custody."
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "sourceId": "cad-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+EM&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
          "requiredFor": "Candidate-specific close-approach cadence, distance, velocity, diameter fields, and CAD uncertainty custody."
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "sourceId": "mpc",
          "method": "manual-review",
          "url": "https://minorplanetcenter.net/data",
          "requiredFor": "Designation lineage, observation arc, residual context, and bridge between MPC observation records and SBDB/CAD identity."
        }
      ],
      "archiveSearchTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 EM",
            "2026 EM asteroid taxonomy",
            "2026 EM spectra",
            "2026 EM mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 EM",
            "2026 EM asteroid taxonomy",
            "2026 EM spectra",
            "2026 EM mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 EM",
            "2026 EM asteroid taxonomy",
            "2026 EM spectra",
            "2026 EM mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        }
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "acceptanceGates": [
        "Candidate designation resolves unambiguously across SBDB, CAD, and MPC records.",
        "All source payloads include query URL, timestamp, units, uncertainty, license/use note, and hashes.",
        "Taxonomy, spectra, or mission/archive evidence is attached before any resource-class hypothesis is promoted.",
        "If no composition evidence is found, the work order closes as no-promotion with blockers preserved.",
        "Customer-facing reports may reference geometry screening only after source-use clearance."
      ],
      "stopConditions": [
        "SBDB/CAD/MPC records refer to different objects or ambiguous designations.",
        "Archive search cannot produce a candidate-specific taxonomy, spectra, or mission product.",
        "License or source-use review blocks redistribution or customer use.",
        "Resource class would be inferred only from close-approach geometry or orbit class."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-em-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-5bdb8eb61a495b8a9b53e1cfc73fb5ccdbb5ad0910d3db8a4584ed501c2616f9"
    },
    {
      "id": "small-body-source-work-order-2026-dn5",
      "sourceCandidateId": "cad-2026 DN5",
      "designation": "2026 DN5",
      "name": "2026 DN5",
      "queueRank": 3,
      "reviewPriorityScore": 39.5,
      "currentEvidenceState": "geometry-screen-only",
      "workOrderState": "blocked-until-candidate-specific-source-intake",
      "promotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "sourceQueryTargets": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "sourceId": "sbdb-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+DN5&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
          "requiredFor": "Object identity, orbit solution, physical fields, close-approach cross-check, and uncertainty custody."
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "sourceId": "cad-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+DN5&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
          "requiredFor": "Candidate-specific close-approach cadence, distance, velocity, diameter fields, and CAD uncertainty custody."
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "sourceId": "mpc",
          "method": "manual-review",
          "url": "https://minorplanetcenter.net/data",
          "requiredFor": "Designation lineage, observation arc, residual context, and bridge between MPC observation records and SBDB/CAD identity."
        }
      ],
      "archiveSearchTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 DN5",
            "2026 DN5 asteroid taxonomy",
            "2026 DN5 spectra",
            "2026 DN5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 DN5",
            "2026 DN5 asteroid taxonomy",
            "2026 DN5 spectra",
            "2026 DN5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 DN5",
            "2026 DN5 asteroid taxonomy",
            "2026 DN5 spectra",
            "2026 DN5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        }
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "acceptanceGates": [
        "Candidate designation resolves unambiguously across SBDB, CAD, and MPC records.",
        "All source payloads include query URL, timestamp, units, uncertainty, license/use note, and hashes.",
        "Taxonomy, spectra, or mission/archive evidence is attached before any resource-class hypothesis is promoted.",
        "If no composition evidence is found, the work order closes as no-promotion with blockers preserved.",
        "Customer-facing reports may reference geometry screening only after source-use clearance."
      ],
      "stopConditions": [
        "SBDB/CAD/MPC records refer to different objects or ambiguous designations.",
        "Archive search cannot produce a candidate-specific taxonomy, spectra, or mission product.",
        "License or source-use review blocks redistribution or customer use.",
        "Resource class would be inferred only from close-approach geometry or orbit class."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-dn5-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-620143df6681d87f5385af49ebf5ccc6bd18b20679f3e5e292185d1b5f0327d0"
    },
    {
      "id": "small-body-source-work-order-2026-lx",
      "sourceCandidateId": "cad-2026 LX",
      "designation": "2026 LX",
      "name": "2026 LX",
      "queueRank": 4,
      "reviewPriorityScore": 39.44,
      "currentEvidenceState": "geometry-screen-only",
      "workOrderState": "blocked-until-candidate-specific-source-intake",
      "promotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "sourceQueryTargets": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "sourceId": "sbdb-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+LX&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
          "requiredFor": "Object identity, orbit solution, physical fields, close-approach cross-check, and uncertainty custody."
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "sourceId": "cad-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+LX&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
          "requiredFor": "Candidate-specific close-approach cadence, distance, velocity, diameter fields, and CAD uncertainty custody."
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "sourceId": "mpc",
          "method": "manual-review",
          "url": "https://minorplanetcenter.net/data",
          "requiredFor": "Designation lineage, observation arc, residual context, and bridge between MPC observation records and SBDB/CAD identity."
        }
      ],
      "archiveSearchTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 LX",
            "2026 LX asteroid taxonomy",
            "2026 LX spectra",
            "2026 LX mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 LX",
            "2026 LX asteroid taxonomy",
            "2026 LX spectra",
            "2026 LX mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 LX",
            "2026 LX asteroid taxonomy",
            "2026 LX spectra",
            "2026 LX mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        }
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "acceptanceGates": [
        "Candidate designation resolves unambiguously across SBDB, CAD, and MPC records.",
        "All source payloads include query URL, timestamp, units, uncertainty, license/use note, and hashes.",
        "Taxonomy, spectra, or mission/archive evidence is attached before any resource-class hypothesis is promoted.",
        "If no composition evidence is found, the work order closes as no-promotion with blockers preserved.",
        "Customer-facing reports may reference geometry screening only after source-use clearance."
      ],
      "stopConditions": [
        "SBDB/CAD/MPC records refer to different objects or ambiguous designations.",
        "Archive search cannot produce a candidate-specific taxonomy, spectra, or mission product.",
        "License or source-use review blocks redistribution or customer use.",
        "Resource class would be inferred only from close-approach geometry or orbit class."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-lx-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-8c14435b45122ce12954b3cdff703649a3c597e4399f447c3d66d06c0615617e"
    },
    {
      "id": "small-body-source-work-order-2026-ku1",
      "sourceCandidateId": "cad-2026 KU1",
      "designation": "2026 KU1",
      "name": "2026 KU1",
      "queueRank": 5,
      "reviewPriorityScore": 36.59,
      "currentEvidenceState": "geometry-screen-only",
      "workOrderState": "blocked-until-candidate-specific-source-intake",
      "promotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "sourceQueryTargets": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "sourceId": "sbdb-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+KU1&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
          "requiredFor": "Object identity, orbit solution, physical fields, close-approach cross-check, and uncertainty custody."
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "sourceId": "cad-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+KU1&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
          "requiredFor": "Candidate-specific close-approach cadence, distance, velocity, diameter fields, and CAD uncertainty custody."
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "sourceId": "mpc",
          "method": "manual-review",
          "url": "https://minorplanetcenter.net/data",
          "requiredFor": "Designation lineage, observation arc, residual context, and bridge between MPC observation records and SBDB/CAD identity."
        }
      ],
      "archiveSearchTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 KU1",
            "2026 KU1 asteroid taxonomy",
            "2026 KU1 spectra",
            "2026 KU1 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 KU1",
            "2026 KU1 asteroid taxonomy",
            "2026 KU1 spectra",
            "2026 KU1 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 KU1",
            "2026 KU1 asteroid taxonomy",
            "2026 KU1 spectra",
            "2026 KU1 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        }
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "acceptanceGates": [
        "Candidate designation resolves unambiguously across SBDB, CAD, and MPC records.",
        "All source payloads include query URL, timestamp, units, uncertainty, license/use note, and hashes.",
        "Taxonomy, spectra, or mission/archive evidence is attached before any resource-class hypothesis is promoted.",
        "If no composition evidence is found, the work order closes as no-promotion with blockers preserved.",
        "Customer-facing reports may reference geometry screening only after source-use clearance."
      ],
      "stopConditions": [
        "SBDB/CAD/MPC records refer to different objects or ambiguous designations.",
        "Archive search cannot produce a candidate-specific taxonomy, spectra, or mission product.",
        "License or source-use review blocks redistribution or customer use.",
        "Resource class would be inferred only from close-approach geometry or orbit class."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-ku1-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-9f67dd23c5090587d15155d69e13638d980daaa9b46e66af99b0a82c007689d3"
    },
    {
      "id": "small-body-source-work-order-2026-fs5",
      "sourceCandidateId": "cad-2026 FS5",
      "designation": "2026 FS5",
      "name": "2026 FS5",
      "queueRank": 6,
      "reviewPriorityScore": 30.19,
      "currentEvidenceState": "geometry-screen-only",
      "workOrderState": "blocked-until-candidate-specific-source-intake",
      "promotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "sourceQueryTargets": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "sourceId": "sbdb-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+FS5&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
          "requiredFor": "Object identity, orbit solution, physical fields, close-approach cross-check, and uncertainty custody."
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "sourceId": "cad-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+FS5&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
          "requiredFor": "Candidate-specific close-approach cadence, distance, velocity, diameter fields, and CAD uncertainty custody."
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "sourceId": "mpc",
          "method": "manual-review",
          "url": "https://minorplanetcenter.net/data",
          "requiredFor": "Designation lineage, observation arc, residual context, and bridge between MPC observation records and SBDB/CAD identity."
        }
      ],
      "archiveSearchTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 FS5",
            "2026 FS5 asteroid taxonomy",
            "2026 FS5 spectra",
            "2026 FS5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 FS5",
            "2026 FS5 asteroid taxonomy",
            "2026 FS5 spectra",
            "2026 FS5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 FS5",
            "2026 FS5 asteroid taxonomy",
            "2026 FS5 spectra",
            "2026 FS5 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        }
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "acceptanceGates": [
        "Candidate designation resolves unambiguously across SBDB, CAD, and MPC records.",
        "All source payloads include query URL, timestamp, units, uncertainty, license/use note, and hashes.",
        "Taxonomy, spectra, or mission/archive evidence is attached before any resource-class hypothesis is promoted.",
        "If no composition evidence is found, the work order closes as no-promotion with blockers preserved.",
        "Customer-facing reports may reference geometry screening only after source-use clearance."
      ],
      "stopConditions": [
        "SBDB/CAD/MPC records refer to different objects or ambiguous designations.",
        "Archive search cannot produce a candidate-specific taxonomy, spectra, or mission product.",
        "License or source-use review blocks redistribution or customer use.",
        "Resource class would be inferred only from close-approach geometry or orbit class."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-fs5-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-09109b23d6398297094ed3d3b256f48c4a47f25c782a345c919d9de7ab6154c9"
    },
    {
      "id": "small-body-source-work-order-2026-et3",
      "sourceCandidateId": "cad-2026 ET3",
      "designation": "2026 ET3",
      "name": "2026 ET3",
      "queueRank": 7,
      "reviewPriorityScore": 25.97,
      "currentEvidenceState": "geometry-screen-only",
      "workOrderState": "blocked-until-candidate-specific-source-intake",
      "promotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "sourceQueryTargets": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "sourceId": "sbdb-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+ET3&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
          "requiredFor": "Object identity, orbit solution, physical fields, close-approach cross-check, and uncertainty custody."
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "sourceId": "cad-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+ET3&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
          "requiredFor": "Candidate-specific close-approach cadence, distance, velocity, diameter fields, and CAD uncertainty custody."
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "sourceId": "mpc",
          "method": "manual-review",
          "url": "https://minorplanetcenter.net/data",
          "requiredFor": "Designation lineage, observation arc, residual context, and bridge between MPC observation records and SBDB/CAD identity."
        }
      ],
      "archiveSearchTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 ET3",
            "2026 ET3 asteroid taxonomy",
            "2026 ET3 spectra",
            "2026 ET3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 ET3",
            "2026 ET3 asteroid taxonomy",
            "2026 ET3 spectra",
            "2026 ET3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 ET3",
            "2026 ET3 asteroid taxonomy",
            "2026 ET3 spectra",
            "2026 ET3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        }
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "acceptanceGates": [
        "Candidate designation resolves unambiguously across SBDB, CAD, and MPC records.",
        "All source payloads include query URL, timestamp, units, uncertainty, license/use note, and hashes.",
        "Taxonomy, spectra, or mission/archive evidence is attached before any resource-class hypothesis is promoted.",
        "If no composition evidence is found, the work order closes as no-promotion with blockers preserved.",
        "Customer-facing reports may reference geometry screening only after source-use clearance."
      ],
      "stopConditions": [
        "SBDB/CAD/MPC records refer to different objects or ambiguous designations.",
        "Archive search cannot produce a candidate-specific taxonomy, spectra, or mission product.",
        "License or source-use review blocks redistribution or customer use.",
        "Resource class would be inferred only from close-approach geometry or orbit class."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-et3-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-5307e6095ba506ff9e307252b1b93187560a31d7d43a125df1226e73c39a22d7"
    },
    {
      "id": "small-body-source-work-order-2026-jn4",
      "sourceCandidateId": "cad-2026 JN4",
      "designation": "2026 JN4",
      "name": "2026 JN4",
      "queueRank": 8,
      "reviewPriorityScore": 24.65,
      "currentEvidenceState": "geometry-screen-only",
      "workOrderState": "blocked-until-candidate-specific-source-intake",
      "promotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "sourceQueryTargets": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "sourceId": "sbdb-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+JN4&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
          "requiredFor": "Object identity, orbit solution, physical fields, close-approach cross-check, and uncertainty custody."
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "sourceId": "cad-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+JN4&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
          "requiredFor": "Candidate-specific close-approach cadence, distance, velocity, diameter fields, and CAD uncertainty custody."
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "sourceId": "mpc",
          "method": "manual-review",
          "url": "https://minorplanetcenter.net/data",
          "requiredFor": "Designation lineage, observation arc, residual context, and bridge between MPC observation records and SBDB/CAD identity."
        }
      ],
      "archiveSearchTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 JN4",
            "2026 JN4 asteroid taxonomy",
            "2026 JN4 spectra",
            "2026 JN4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 JN4",
            "2026 JN4 asteroid taxonomy",
            "2026 JN4 spectra",
            "2026 JN4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 JN4",
            "2026 JN4 asteroid taxonomy",
            "2026 JN4 spectra",
            "2026 JN4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        }
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "acceptanceGates": [
        "Candidate designation resolves unambiguously across SBDB, CAD, and MPC records.",
        "All source payloads include query URL, timestamp, units, uncertainty, license/use note, and hashes.",
        "Taxonomy, spectra, or mission/archive evidence is attached before any resource-class hypothesis is promoted.",
        "If no composition evidence is found, the work order closes as no-promotion with blockers preserved.",
        "Customer-facing reports may reference geometry screening only after source-use clearance."
      ],
      "stopConditions": [
        "SBDB/CAD/MPC records refer to different objects or ambiguous designations.",
        "Archive search cannot produce a candidate-specific taxonomy, spectra, or mission product.",
        "License or source-use review blocks redistribution or customer use.",
        "Resource class would be inferred only from close-approach geometry or orbit class."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jn4-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-db8b7e318dfb4712806ffcd94b5e853eb00e04027da223999f907e3dfd42a8b4"
    },
    {
      "id": "small-body-source-work-order-2026-jv3",
      "sourceCandidateId": "cad-2026 JV3",
      "designation": "2026 JV3",
      "name": "2026 JV3",
      "queueRank": 9,
      "reviewPriorityScore": 24.51,
      "currentEvidenceState": "geometry-screen-only",
      "workOrderState": "blocked-until-candidate-specific-source-intake",
      "promotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "sourceQueryTargets": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "sourceId": "sbdb-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+JV3&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
          "requiredFor": "Object identity, orbit solution, physical fields, close-approach cross-check, and uncertainty custody."
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "sourceId": "cad-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+JV3&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
          "requiredFor": "Candidate-specific close-approach cadence, distance, velocity, diameter fields, and CAD uncertainty custody."
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "sourceId": "mpc",
          "method": "manual-review",
          "url": "https://minorplanetcenter.net/data",
          "requiredFor": "Designation lineage, observation arc, residual context, and bridge between MPC observation records and SBDB/CAD identity."
        }
      ],
      "archiveSearchTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 JV3",
            "2026 JV3 asteroid taxonomy",
            "2026 JV3 spectra",
            "2026 JV3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 JV3",
            "2026 JV3 asteroid taxonomy",
            "2026 JV3 spectra",
            "2026 JV3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 JV3",
            "2026 JV3 asteroid taxonomy",
            "2026 JV3 spectra",
            "2026 JV3 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        }
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "acceptanceGates": [
        "Candidate designation resolves unambiguously across SBDB, CAD, and MPC records.",
        "All source payloads include query URL, timestamp, units, uncertainty, license/use note, and hashes.",
        "Taxonomy, spectra, or mission/archive evidence is attached before any resource-class hypothesis is promoted.",
        "If no composition evidence is found, the work order closes as no-promotion with blockers preserved.",
        "Customer-facing reports may reference geometry screening only after source-use clearance."
      ],
      "stopConditions": [
        "SBDB/CAD/MPC records refer to different objects or ambiguous designations.",
        "Archive search cannot produce a candidate-specific taxonomy, spectra, or mission product.",
        "License or source-use review blocks redistribution or customer use.",
        "Resource class would be inferred only from close-approach geometry or orbit class."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jv3-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-ae4f5464fe7a729075d1796422f376bef5116a139fa7afe89e1f39f2d18c489f"
    },
    {
      "id": "small-body-source-work-order-2026-hz4",
      "sourceCandidateId": "cad-2026 HZ4",
      "designation": "2026 HZ4",
      "name": "2026 HZ4",
      "queueRank": 10,
      "reviewPriorityScore": 24.43,
      "currentEvidenceState": "geometry-screen-only",
      "workOrderState": "blocked-until-candidate-specific-source-intake",
      "promotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "missingEvidence": [
        "sbdb-orbit-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product",
        "source-use-clearance"
      ],
      "sourceQueryTargets": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "sourceId": "sbdb-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+HZ4&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
          "requiredFor": "Object identity, orbit solution, physical fields, close-approach cross-check, and uncertainty custody."
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "sourceId": "cad-api",
          "method": "GET",
          "url": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+HZ4&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
          "requiredFor": "Candidate-specific close-approach cadence, distance, velocity, diameter fields, and CAD uncertainty custody."
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "sourceId": "mpc",
          "method": "manual-review",
          "url": "https://minorplanetcenter.net/data",
          "requiredFor": "Designation lineage, observation arc, residual context, and bridge between MPC observation records and SBDB/CAD identity."
        }
      ],
      "archiveSearchTargets": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "baseUrl": "https://pds.nasa.gov/datasearch/data-search/",
          "plannedSearchTerms": [
            "2026 HZ4",
            "2026 HZ4 asteroid taxonomy",
            "2026 HZ4 spectra",
            "2026 HZ4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "baseUrl": "https://archives.esac.esa.int/psa/",
          "plannedSearchTerms": [
            "2026 HZ4",
            "2026 HZ4 asteroid taxonomy",
            "2026 HZ4 spectra",
            "2026 HZ4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "baseUrl": "https://darts.isas.jaxa.jp/",
          "plannedSearchTerms": [
            "2026 HZ4",
            "2026 HZ4 asteroid taxonomy",
            "2026 HZ4 spectra",
            "2026 HZ4 mission archive product"
          ],
          "requiredCaptureFields": [
            "archive product id or dataset id",
            "instrument or observation method",
            "retrieval timestamp",
            "citation and license/use note",
            "raw payload hash and normalized payload hash"
          ]
        }
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "acceptanceGates": [
        "Candidate designation resolves unambiguously across SBDB, CAD, and MPC records.",
        "All source payloads include query URL, timestamp, units, uncertainty, license/use note, and hashes.",
        "Taxonomy, spectra, or mission/archive evidence is attached before any resource-class hypothesis is promoted.",
        "If no composition evidence is found, the work order closes as no-promotion with blockers preserved.",
        "Customer-facing reports may reference geometry screening only after source-use clearance."
      ],
      "stopConditions": [
        "SBDB/CAD/MPC records refer to different objects or ambiguous designations.",
        "Archive search cannot produce a candidate-specific taxonomy, spectra, or mission product.",
        "License or source-use review blocks redistribution or customer use.",
        "Resource class would be inferred only from close-approach geometry or orbit class."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-hz4-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "workOrderHash": "sha256-ca56492f342a3ffd2c86d75c51ea4e032263dc65138f58c461ebb42a700b4b92"
    }
  ],
  "linkedAssumption": {
    "id": "assumption-resource-composition-unknown",
    "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
    "state": "blocked-until-source-backed",
    "uncertainty": "High",
    "impact": {
      "assumptionId": "assumption-resource-composition-unknown",
      "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
      "state": "blocked-until-source-backed",
      "owner": "Resource ledger",
      "uncertainty": "High",
      "businessQuestion": "Which resource-dependent scenarios degrade when composition evidence is held at unknown?",
      "affectedScenarioIds": [
        "hybrid",
        "asteroid-first",
        "mercury-orbit",
        "mercury-polar"
      ],
      "stressWeights": {
        "benefits": {
          "resourceConfidence": 1.25,
          "optionality": 0.92
        },
        "risks": {
          "feedstock": 1.35
        }
      },
      "sourceCoverage": {
        "sourceCount": 3,
        "missingSourceIds": [],
        "primarySourceCount": 3,
        "recordHashes": [
          "fnv1a32-7c477cc2",
          "fnv1a32-93c0fe91",
          "fnv1a32-ba0c45bb"
        ]
      },
      "scenarioImpacts": [
        {
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "baseRank": 2,
          "stressedRank": 2,
          "rankDelta": 0,
          "baseUtility": 65.69,
          "stressedUtility": 64.83,
          "utilityDelta": -0.86
        },
        {
          "scenarioId": "asteroid-first",
          "name": "Asteroid Feedstock-first",
          "baseRank": 3,
          "stressedRank": 3,
          "rankDelta": 0,
          "baseUtility": 51.37,
          "stressedUtility": 49.69,
          "utilityDelta": -1.68
        },
        {
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "baseRank": 4,
          "stressedRank": 4,
          "rankDelta": 0,
          "baseUtility": 42.95,
          "stressedUtility": 42.13,
          "utilityDelta": -0.82
        },
        {
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "baseRank": 6,
          "stressedRank": 6,
          "rankDelta": 0,
          "baseUtility": 37.95,
          "stressedUtility": 37.91,
          "utilityDelta": -0.04
        }
      ],
      "maxRankShift": 0,
      "maxUtilityDelta": 1.68,
      "stressedWinner": {
        "scenarioId": "moon-first",
        "name": "Moon-first Bootstrap",
        "utility": 66.89
      },
      "stressedUncertainty": {
        "iterations": 128,
        "seed": "assumption-resource-composition-unknown-stress",
        "winner": "moon-first",
        "highestWinProbability": 83.59
      },
      "reviewGate": {
        "promotionAllowed": false,
        "state": "blocked-for-business-proof",
        "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion.",
        "riskIfWrong": "Candidate feedstock rankings could imply unavailable or unmeasured materials."
      },
      "impactHash": "sha256-6d5911577e95f4f378f9c3b42381e039f24031c5391857cc77eb0fc0e1658c49"
    }
  },
  "globalBlockers": [
    "Synthetic candidates must be replaced with object-specific SBDB/CAD records.",
    "CAD geometry candidate evidence exists only as screening input until live capture and reviewer approval pass.",
    "MPC observation context must be attached where orbit confidence affects resource decisions.",
    "Taxonomy, spectra, or mission/archive products are required before composition can promote.",
    "Close approach frequency and low v-infinity are logistics signals, not resource evidence."
  ],
  "candidateRecords": [
    {
      "candidateId": "candidate-a",
      "name": "NEA screen A",
      "status": "Synthetic workflow record",
      "note": "Synthetic reviewer snapshot; replace with SBDB query record before promotion.",
      "sourceIds": [],
      "inputHash": "sha256-567da1d4dbcc4528b14f176e02ac59bde53a4f1cd9f8daf5d3c31f31365231b5",
      "geometryScore": 40.6,
      "evidenceCompletenessScore": 0,
      "candidateInputs": {
        "closeApproachFrequency": 0.8,
        "vInfKms": 5.2,
        "diameterConfidence": 0.65,
        "orbitAccessibility": 0.76,
        "sourceUncertainty": 0.42,
        "resourceClassConfidence": 0.35
      },
      "evidence": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "label": "SBDB orbit and physical-property record",
          "requiredFor": "Orbit solution, condition code, absolute magnitude, diameter fields, and physical property provenance.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "label": "CAD close-approach record",
          "requiredFor": "Close approach cadence, nominal distance, relative velocity, and date range.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            }
          ]
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "label": "MPC observation bridge",
          "requiredFor": "Observation context that explains orbit confidence and designation lineage.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "evidenceTypeId": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "requiredFor": "Resource-class evidence; close approaches cannot imply composition.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "evidenceTypeId": "mission-or-archive-product",
          "label": "Mission/archive product",
          "requiredFor": "Independent mission data or archive product where material claims depend on composition.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "cad-close-approach-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product"
      ],
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-resource-promotion",
        "blockers": [
          "Candidate is marked promotionBlocked in source data.",
          "Missing evidence types: sbdb-orbit-record, cad-close-approach-record, mpc-observation-bridge, taxonomy-spectra-record, mission-or-archive-product",
          "No taxonomy, spectra, or mission data supports resource composition.",
          "Synthetic workflow record must be replaced with object-specific SBDB/CAD/MPC records.",
          "Resource value cannot promote from close-approach geometry alone."
        ],
        "allowedUse": "May be used only as a scanner workflow record, not as a resource or feedstock claim."
      },
      "candidateHash": "sha256-b8679daf26d848b4c8afdff23abe3202e792baea76954b3aa15998400ea5e7f3"
    },
    {
      "candidateId": "candidate-b",
      "name": "NEA screen B",
      "status": "Synthetic workflow record",
      "note": "Higher velocity demo record; replace with CAD close-approach data before promotion.",
      "sourceIds": [],
      "inputHash": "sha256-f9e3ea25f1268435e3ab7e6072489c6ec1d7be091ada1633053b5ffb526fec77",
      "geometryScore": 18.740000000000006,
      "evidenceCompletenessScore": 0,
      "candidateInputs": {
        "closeApproachFrequency": 0.55,
        "vInfKms": 8.1,
        "diameterConfidence": 0.72,
        "orbitAccessibility": 0.5,
        "sourceUncertainty": 0.48,
        "resourceClassConfidence": 0.38
      },
      "evidence": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "label": "SBDB orbit and physical-property record",
          "requiredFor": "Orbit solution, condition code, absolute magnitude, diameter fields, and physical property provenance.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "label": "CAD close-approach record",
          "requiredFor": "Close approach cadence, nominal distance, relative velocity, and date range.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            }
          ]
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "label": "MPC observation bridge",
          "requiredFor": "Observation context that explains orbit confidence and designation lineage.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "evidenceTypeId": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "requiredFor": "Resource-class evidence; close approaches cannot imply composition.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "evidenceTypeId": "mission-or-archive-product",
          "label": "Mission/archive product",
          "requiredFor": "Independent mission data or archive product where material claims depend on composition.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "cad-close-approach-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product"
      ],
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-resource-promotion",
        "blockers": [
          "Candidate is marked promotionBlocked in source data.",
          "Missing evidence types: sbdb-orbit-record, cad-close-approach-record, mpc-observation-bridge, taxonomy-spectra-record, mission-or-archive-product",
          "No taxonomy, spectra, or mission data supports resource composition.",
          "Synthetic workflow record must be replaced with object-specific SBDB/CAD/MPC records.",
          "Resource value cannot promote from close-approach geometry alone."
        ],
        "allowedUse": "May be used only as a scanner workflow record, not as a resource or feedstock claim."
      },
      "candidateHash": "sha256-5af29ba8794df1376b777f09891d3363299606735007cbada2aef067b1c5d5c0"
    },
    {
      "candidateId": "candidate-c",
      "name": "NEA screen C",
      "status": "Synthetic workflow record",
      "note": "Promising geometry demo record; resource class remains unknown until sourced.",
      "sourceIds": [],
      "inputHash": "sha256-fbf7a00e9498030867cf99445979475f5e4e56ae155f11688152a14c816eb0fb",
      "geometryScore": 37.42,
      "evidenceCompletenessScore": 0,
      "candidateInputs": {
        "closeApproachFrequency": 0.7,
        "vInfKms": 4.7,
        "diameterConfidence": 0.55,
        "orbitAccessibility": 0.82,
        "sourceUncertainty": 0.5,
        "resourceClassConfidence": 0.28
      },
      "evidence": [
        {
          "evidenceTypeId": "sbdb-orbit-record",
          "label": "SBDB orbit and physical-property record",
          "requiredFor": "Orbit solution, condition code, absolute magnitude, diameter fields, and physical property provenance.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "sbdb-api",
              "title": "JPL Small-Body Database API",
              "trust": "primary",
              "sourceType": "small-body-orbit-api",
              "recordHash": "fnv1a32-93c0fe91",
              "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
              "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
              "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats."
            }
          ]
        },
        {
          "evidenceTypeId": "cad-close-approach-record",
          "label": "CAD close-approach record",
          "requiredFor": "Close approach cadence, nominal distance, relative velocity, and date range.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "cad-api",
              "title": "SBDB Close Approach Data API",
              "trust": "primary",
              "sourceType": "close-approach-api",
              "recordHash": "fnv1a32-ba0c45bb",
              "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
              "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
              "uncertaintyMode": "Nominal approach values with orbit-solution caveats."
            }
          ]
        },
        {
          "evidenceTypeId": "mpc-observation-bridge",
          "label": "MPC observation bridge",
          "requiredFor": "Observation context that explains orbit confidence and designation lineage.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "mpc",
              "title": "Minor Planet Center Data",
              "trust": "primary",
              "sourceType": "small-body-observation-archive",
              "recordHash": "fnv1a32-62694497",
              "url": "https://minorplanetcenter.net/data",
              "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
              "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD."
            }
          ]
        },
        {
          "evidenceTypeId": "taxonomy-spectra-record",
          "label": "Taxonomy or spectra record",
          "requiredFor": "Resource-class evidence; close approaches cannot imply composition.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        },
        {
          "evidenceTypeId": "mission-or-archive-product",
          "label": "Mission/archive product",
          "requiredFor": "Independent mission data or archive product where material claims depend on composition.",
          "satisfied": false,
          "attachedSourceIds": [],
          "acceptedSourceRefs": [
            {
              "sourceId": "pds",
              "title": "Planetary Data System",
              "trust": "primary",
              "sourceType": "mission-data-archive",
              "recordHash": "fnv1a32-7c477cc2",
              "url": "https://pds.nasa.gov/datasearch/data-search/",
              "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
              "uncertaintyMode": "Instrument/product calibration metadata."
            },
            {
              "sourceId": "esa-psa",
              "title": "ESA Planetary Science Archive",
              "trust": "primary",
              "sourceType": "planetary-mission-archive",
              "recordHash": "fnv1a32-5c0abe4d",
              "url": "https://archives.esac.esa.int/psa/",
              "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
              "uncertaintyMode": "Product calibration, processing level, and instrument caveats."
            },
            {
              "sourceId": "jaxa-darts",
              "title": "DARTS Space Science Data Archive",
              "trust": "primary",
              "sourceType": "space-science-archive",
              "recordHash": "fnv1a32-e07b656d",
              "url": "https://darts.isas.jaxa.jp/",
              "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
              "uncertaintyMode": "Dataset calibration and archive release notes."
            }
          ]
        }
      ],
      "missingEvidence": [
        "sbdb-orbit-record",
        "cad-close-approach-record",
        "mpc-observation-bridge",
        "taxonomy-spectra-record",
        "mission-or-archive-product"
      ],
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-resource-promotion",
        "blockers": [
          "Candidate is marked promotionBlocked in source data.",
          "Missing evidence types: sbdb-orbit-record, cad-close-approach-record, mpc-observation-bridge, taxonomy-spectra-record, mission-or-archive-product",
          "No taxonomy, spectra, or mission data supports resource composition.",
          "Synthetic workflow record must be replaced with object-specific SBDB/CAD/MPC records.",
          "Resource value cannot promote from close-approach geometry alone."
        ],
        "allowedUse": "May be used only as a scanner workflow record, not as a resource or feedstock claim."
      },
      "candidateHash": "sha256-4e44abd8b5d4f8cb03ec34bb26654ecbbfdcefa0f946871aa57533f79dfc0f27"
    }
  ],
  "ledgerHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
}
;
